<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@ds/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <tr
    :class="cn(
      'border-b border-border transition-colors duration-ds-fast ease-ds-standard hover:bg-muted/25 data-[state=selected]:bg-muted',
      props.class,
    )"
  >
    <slot />
  </tr>
</template>
